import { createContext } from "react";

import { Role } from "types/generated";

import { UserManagementActivationStatus } from "../../types";
import { ApiKeyCreationStep } from "./constants";

type ApiKeyCreateWizardContextProps = {
  currentStep: ApiKeyCreationStep;
  setCurrentStep: (step: ApiKeyCreationStep) => void;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  availableRoles: Pick<Role, "id" | "name" | "slug" | "isSystem">[];
  rolesLoading: boolean;
  spaceAdminRole: Pick<Role, "id" | "name" | "slug" | "isSystem"> | undefined;
  activationStatus: UserManagementActivationStatus;
  onClose: () => void;
};

export const ApiKeyCreateWizardContext = createContext<ApiKeyCreateWizardContextProps | undefined>(
  undefined
);
ApiKeyCreateWizardContext.displayName = "ApiKeyCreateWizardContext";
